// const suiteCrmUrl = "http://loc.suitecrm.com.au/";
// const suiteCrmUrl = "http://suite.pure-electric.local/";
const suiteCrmUrl = "https://suitecrm.pure-electric.com.au/";
const waterCheckQualityUrl = "index.php?entryPoint=APICheckWaterQuality";
const getProductDataUrl = "index.php?entryPoint=APIGetProductForNewSanden";
const getStcVeec = "index.php?entryPoint=APTGetSTCVEEC";
const checkEmailLead = "index.php?entryPoint=APIGetLeadByEmail";
const getSMSTemplate = "index.php?entryPoint=APIGetSMSTemplateFromSuiteById";
const getSMSSignatureTemplate = "index.php?entryPoint=APTGetSignatureUser";
const getNote = "index.php?entryPoint=CRUD_quote_note";
const getSubsidy = "index.php?entryPoint=APIGetProductByCategory&category=Subsidy";
const getBatteryProduct = "index.php?entryPoint=APIGetBatteryProduct";
const generateQuote = "index.php?entryPoint=APIGenerateQuoteBattery";
const saveAndSendPdf = "index.php?entryPoint=APISavePDFAndEmail";
const downloadFileFromPath = "index.php?entryPoint=APIDownloadFileFromPath";
const sendMaildExtraByForm = "index.php?entryPoint=APISendMaildExtraByForm";
const sendSMS = "index.php?entryPoint=APISendSMS";
const updateQuoteAfterSave = "index.php?entryPoint=APIUpdateQuoteAfterSave";
const getDataLead = "index.php?entryPoint=APIGetDataLeads";
const getLeadSource = "index.php?entryPoint=APIGetOptionsDropdown";
const userAuth = "index.php?entryPoint=APIUserAuth";
const getPricingOption = "index.php?entryPoint=loadPricingOption&solarform=get_pricing_option&id_price=";
const getPricingOptionName = 'index.php?entryPoint=loadPricingOption&solarform=get_name_option&form=battery_form';
const getProductInfoByPartNumber = "index.php?entryPoint=APIGetProductInfoByPartNumber&part_number=";

export {
  suiteCrmUrl, 
  waterCheckQualityUrl,
  getProductDataUrl,
  getStcVeec,
  checkEmailLead,
  getSMSTemplate,
  getSMSSignatureTemplate,
  getNote,
  getSubsidy,
  getBatteryProduct,
  generateQuote,
  saveAndSendPdf,
  downloadFileFromPath,
  sendMaildExtraByForm,
  sendSMS,
  updateQuoteAfterSave,
  getDataLead,
  getLeadSource,
  userAuth,
  getPricingOption,
  getPricingOptionName,
  getProductInfoByPartNumber,
}